module.exports = __webpack_public_path__ + "img/antes_despues_173.4ae06c6e.png";